import * as React from "react";
import PropTypes from "prop-types";
import Switch from "@mui/material/Switch";
import { Box } from "@mui/material";
import Swal from "sweetalert2";
import "./Style.scss";
import { update2FAType, check2FA } from "api/api_register2FA";
import imgCollapse from "../../../assets/images/2FA/Shape_collapse.svg";
import imgExpand from "../../../assets/images/2FA/Shape_expand.svg";

function EachMethod2FA({ methodData, setOpenCheckOTPFirst, setOpen2FAChooseType, setType }) {
  const [checked, setChecked] = React.useState(false);
  const user = JSON.parse(localStorage.getItem("user"));
  const { methodTitle, methodContent } = methodData;

  const update2FA = async (type) => {
    await update2FAType(user.username, type);
  };
  const check2FAType = async () => {
    const fatype = await check2FA(user.username);
    if (methodTitle.includes("Email") && fatype === 1) {
      setChecked(true);
    }
    if (methodTitle.includes("SMS") && fatype === 2) {
      setChecked(true);
    }
    if (methodTitle.includes("Google Authenticator") && fatype === 3) {
      setChecked(true);
    }
    if (methodTitle.includes("Microsoft Authenticator") && fatype === 4) {
      setChecked(true);
    }
    if (methodTitle.includes("Mẫu hình") && fatype === 5) {
      setChecked(true);
    }
    if (methodTitle.includes("Vân tay") && fatype === 6) {
      setChecked(true);
    }
    if (methodTitle.includes("Khuôn mặt") && fatype === 7) {
      setChecked(true);
    }
    if (methodTitle.includes("Võng mạc") && fatype === 9) {
      setChecked(true);
    }
    if (methodTitle.includes("Giọng nói") && fatype === 8) {
      setChecked(true);
    }
  };

  React.useEffect(() => {
    check2FAType();
  }, []);

  const [expand, setExpand] = React.useState(false);

  const navigateToOTPPage = (typeName) => {
    setOpen2FAChooseType((prev) => !prev);
    setOpenCheckOTPFirst((prev) => !prev);
    setType(typeName);
  };

  const handleChange = () => {
    setChecked((prev) => !prev);
    if (user.phone === null) {
      Swal.fire({
        title: "Vui lòng cập nhật số điện thoại để thực hiện xác thực 2 bước bằng SMS.",
        icon: "error",
        customClass: {
          popup: "custom-swal-popup", // Lớp tùy chỉnh cho toàn bộ modal
          title: "custom-swal-title", // Lớp tùy chỉnh cho tiêu đề
          content: "custom-swal-content", // Lớp tùy chỉnh cho nội dung
          confirmButton: "custom-swal-button", // Lớp tùy chỉnh cho nút
        },
      });
      update2FA(0);
      setChecked(false);
    } else {
      if (checked === false) {
        if (methodTitle.includes("SMS")) {
          navigateToOTPPage("sms");
        }
        if (methodTitle.includes("Email")) {
          navigateToOTPPage("email");
        }
        if (methodTitle.includes("Google")) {
          navigateToOTPPage("GGA");
        }
        if (methodTitle.includes("Microsoft")) {
          navigateToOTPPage("MCA");
        }
        if (methodTitle.includes("Mẫu hình")) {
          navigateToOTPPage("pattern");
        }
        // if (methodTitle.includes("Vân tay")) {
        //   navigateToOTPPage("fingerprint");
        // }
        // if (methodTitle.includes("Khuôn mặt")) {
        //   navigateToOTPPage("face");
        // }
        // if (methodTitle.includes("Giọng nói")) {
        //   navigateToOTPPage("voice");
        // }
        // if (methodTitle.includes("Võng mạc")) {
        //   navigateToOTPPage("iris");
        // }
      }
      if (checked === true) {
        update2FA(0);
        setChecked(false);
      }
    }
  };

  return (
    <Box
      className="d-flex w-100"
      style={{ borderBottom: "1px var(--blue-blue-100) solid", marginBottom: "10px" }}
    >
      <Box
        onClick={() => {
          setExpand(!expand);
        }}
        role="button"
        tabIndex="0"
        onKeyDown={() => {}}
      >
        <img
          style={{ width: "13px", height: "13px", marginTop: "-13px" }}
          alt="intro2FA"
          src={expand ? imgExpand : imgCollapse}
        />
      </Box>
      <Box style={{ flexGrow: "1", marginLeft: "10px" }}>
        <Box style={{ color: "var(--blue-blue-100)", fontWeight: "600" }} className="fs-16 ">
          {methodTitle}
        </Box>
        {expand ? <Box className="fs-14  magin-left-16">{methodContent}</Box> : null}
      </Box>
      {expand ? (
        <Box className="centered">
          <Switch defaultChecked checked={checked} onChange={handleChange} />
        </Box>
      ) : null}
    </Box>
  );
}
EachMethod2FA.propTypes = {
  methodData: PropTypes.objectOf(PropTypes).isRequired,
  setOpenCheckOTPFirst: PropTypes.func.isRequired,
  setOpen2FAChooseType: PropTypes.func.isRequired,
  setType: PropTypes.func.isRequired,
};
export default EachMethod2FA;
